import { apiProxyRequest } from "Api/apiProxyRequest";
import { BillingProfileStanding } from "../types";

export type UserBillingStandingsResponse = {
  count: number;
  items: BillingProfileStanding[];
};

// Standing for every billing profile the user can see, in one call — used to
// power account-level indicators (nav dot) without per-profile requests.
export const getUserStandingsRequest = (userId: string) => {
  return apiProxyRequest<UserBillingStandingsResponse>(
    `/users/${userId}/billing/profiles/standing`
  );
};
